"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var embla_carousel_1 = __importDefault(require("embla-carousel"));
var collectionNavInit = function () {
    console.log("loading embla for collection nav");
    var mainNavElement = document.querySelector(".collection-nav__carousel");
    if (mainNavElement) {
        var mainViewport = mainNavElement.querySelector(".embla__viewport");
        if (mainViewport) {
            var mainOptions = {
                align: "start",
                breakpoints: {
                    "(min-width: 1024px)": { active: false },
                },
            };
            embla_carousel_1.default(mainViewport, mainOptions);
        }
    }
};
exports.default = collectionNavInit;
